import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-ppl-card',
  standalone: true,
  imports: [],
  templateUrl: './ppl-card.component.html',
  styleUrl: './ppl-card.component.scss',
})
export class PplCardComponent {
  @Input() isPPL = false;
  @Input() text: string;
}
